"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _getObjectField = _interopRequireDefault(require("./getObjectField"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * Groups an array of items by a specified nested field (using a string path).
 *
 * @param items - The array of items to group.
 * @param path - The path string representing the nested field to use for grouping.
 * @returns A record where each key is a unique value of the specified field,
 *          and the value is an array of items with that field value.
 */
function groupArrayByPath(items, path) {
  return items.reduce((groups, item) => {
    const key = (0, _getObjectField.default)(item, path);
    if (key === undefined || key === null) return groups;
    if (!groups[key]) {
      groups[key] = [];
    }
    groups[key].push(item);
    return groups;
  }, {});
}
var _default = exports.default = groupArrayByPath;